'use client';
import { IRepository } from '@/types';
import { Row } from '@/ui/primatives';
import Button from '@/ui/Button';
import * as Icon from '@/ui/Icon';
import { useAuthorization } from '@/hooks/useAuthorization';
import { Simple as Tooltip } from '@/ui/Tooltip';
import { Config } from '@/hooks/useConfig';
import * as format from '@/lib/format';

const MAX_FORKABLE_REPO_SIZE_IN_BYTES = 5 * 1000 * 1000 * 1000;

const ForkButton: React.FC<{ repository: IRepository; hideMobile?: boolean }> = ({ repository, hideMobile }) => {
  const auth = useAuthorization();
  const { config } = Config.useContainer();
  const isForkingEnabled = !!config?.forking_enabled;

  if (!isForkingEnabled) {
    return null;
  }
  const isRepoTooLarge = repository.size > MAX_FORKABLE_REPO_SIZE_IN_BYTES;

  const tooltipContent = auth.isLoggedIn()
    ? `Forking is temporarily disabled for repositories larger than ${format.humanFileSize(MAX_FORKABLE_REPO_SIZE_IN_BYTES)}`
    : 'You must be signed in to fork a dataset';
  const isDisabled = !auth.isLoggedIn() || isRepoTooLarge;
  return (
    <Tooltip content={tooltipContent} disabled={!isDisabled}>
      <Button.Basic
        href={`/${repository.namespace}/${repository.name}/fork`}
        disabled={isDisabled}
        nowrap
        small
        style={{ padding: '5px 15px 5px 15px' }}
        hideMobile={hideMobile}
      >
        <Row gap={10} alignItems="center">
          <Icon.Fork size="12px" />
          <span>Fork</span>
        </Row>
      </Button.Basic>
    </Tooltip>
  );
};

export default ForkButton;
